import React, { Component } from "react"
import moment from "moment"
import ReportCard from "app/components/normal/pgs/ReportCard"
import { Modal } from "antd"
import { Route, withRouter } from 'react-router-dom'
import ReportDetail from "app/components/normal/pgs/ReportDetail"

import { observer, inject } from "mobx-react"

@inject("store", 'entrance')@observer
class DataTable extends Component {
  state = {
    reportGroupData: {}
  }

  componentDidMount() {
    const { list: { getTableData, updateTableData, updateQueryMap } } = this.props.store.report
    let start=  moment(moment() - 3 * 1000 * 3600 * 24).format("YYYY-MM-DD")

    updateQueryMap({ limit: null, start: start })
    getTableData()
    .then(
      res => {
        updateTableData(res)
        const pathArr = location.pathname.split('/')
        const reportId = pathArr.slice(-1)[0]
        if (pathArr.slice(-2)[0] === 'detail') {
          this.initDetailData(reportId)
        }
      }
    )
  }

  /**
   * 只会在刷新页面的时候调用
   **/
  initDetailData (reportId) {
    const { getDetailData, list: { tableData } } = this.props.store.report

    let reportGroupData = tableData.find(
      data => {
        let index = data.reportList.findIndex(report => report.reportId === reportId)
        if (index > -1) {
          this.setState({
            dataIndex: index
          })
        }
        return index > -1
      }
    )

    this.setState({reportGroupData})

    getDetailData(reportId)
  }

  dataSwitch = (index, record) => {
    let { getDetailData, clearDetailData } = this.props.store.report

    clearDetailData()

    this.setState({
      dataIndex: index,
    })

    getDetailData(record.reportId)
      .then(res => {
        record.isRead = true
      })
  }

  openReportDetail = (data, record) => {
    let { getDetailData, clearDetailData } = this.props.store.report
    let {history, match} = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    clearDetailData()

    this.setState({
      dataIndex: index,
      reportGroupData: data
    })

    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true
      })
    history.push(`${match.url}/detail/${reportId}`)
  }

  render() {
    let { report: { list: { tableData } }, report } = this.props.store
    const { match, history, entrance } = this.props
    const { reportGroupData, dataIndex } = this.state
    let tmp = report.detailData
    return (
      <div>
        {tableData.slice().length!==0 ?
            <h2 className="sub-title">最新报告</h2> : <h2 className="sub-title-disable">今日尚无最新报告</h2> }
        {tableData.slice().map((item, index) => {
          return <ReportCard onOpenDetail={this.openReportDetail} key={index} data={item} store={report}/>
        })}
        {/* 报告详情modal */}
        <Route
          path={`${match.url}/detail/:id`}
          render={() => {
            return (
              <Modal
                title="报告详情"
                width={1172}
                footer={0}
                maskClosable={false}
                visible={true}
                onCancel={() => {
                  history.replace(match.url)
                }}
                className="detail-modal"
              >
                <ReportDetail
                  data={reportGroupData}
                  index={dataIndex}
                  detailData={report.detailData}
                  reportList={reportGroupData.reportList}
                  templates={entrance.templates}
                  dataSwitch={this.dataSwitch}
                  store={report}
                  groupId={reportGroupData.groupId}
                />
              </Modal>
            )
          }}
        />

      </div>
    )
  }
}

export default withRouter(DataTable)



// WEBPACK FOOTER //
// ./src/app/pages/pgs/dashboard/containers/DataTable.js